const IDP_KEY       = 'idp';                  // one canonical key
const REDIRECT_KEY  = 'oidc_redirect_uri';    // one canonical key

export function setIdp(idp: string): void   { localStorage.setItem(IDP_KEY, idp); }
export function getIdp(): string            { return localStorage.getItem(IDP_KEY)       || ''; }
export function clearIdp(): void            { localStorage.removeItem(IDP_KEY); }

export function setRedirect(uri: string): void { localStorage.setItem(REDIRECT_KEY, uri); }
export function getRedirect(): string          { return localStorage.getItem(REDIRECT_KEY) || ''; }
export function clearRedirect(): void          { localStorage.removeItem(REDIRECT_KEY); }
